import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCreateMessagesRequest = { messages: '_message' };
var _bulkCreateMessagesResponse = { messages: '_message' };
var _listMessagesRequest = {};
var _listMessagesResponse = { messages: '_message' };
var _message = { createdDate: 'google.protobuf.Timestamp' };
function resolveWixInnovationAssistantWidgetV1ChatWidgetUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wix-assistant-widget',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Bulk creates messages.
 *
 * This method must be called using the site visitor or site member identity ([SDK](https://dev.wix.com/docs/sdk/articles/get-started/about-identities#site-member) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/about-identities#site-member)) to identify the site visitor that is creating the messages.
 */
export function bulkCreateMessages(payload) {
    var _a = serializer(_bulkCreateMessagesRequest, { _message: _message }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateMessagesResponse, {
        _message: _message,
    }).fromJSON;
    function __bulkCreateMessages(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.innovation.widget.v1.message',
            method: 'POST',
            methodFqn: 'wix.innovation.assistant.widget.v1.ChatWidget.BulkCreateMessages',
            url: resolveWixInnovationAssistantWidgetV1ChatWidgetUrl({
                protoPath: '/v1/bulk/messages/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateMessages.fromReq = fromReq;
    __bulkCreateMessages.__isAmbassador = true;
    return __bulkCreateMessages;
}
/**
 * Retrieves a list of messages.
 *
 * Up to 100 Messages can be returned per request.
 *
 * This method must be called using the site visitor or site member identity ([SDK](https://dev.wix.com/docs/sdk/articles/get-started/about-identities#site-member) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/about-identities#site-member)) to identify the site visitor that is retrieving the messages.
 */
export function listMessages(payload) {
    var _a = serializer(_listMessagesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listMessagesResponse, { _message: _message }).fromJSON;
    function __listMessages(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.innovation.widget.v1.message',
            method: 'GET',
            methodFqn: 'wix.innovation.assistant.widget.v1.ChatWidget.ListMessages',
            url: resolveWixInnovationAssistantWidgetV1ChatWidgetUrl({
                protoPath: '/v1/messages/list',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listMessages.fromReq = fromReq;
    __listMessages.__isAmbassador = true;
    return __listMessages;
}
//# sourceMappingURL=http.impl.js.map